/* eslint-disable no-useless-computed-key */
import { Box, IconButton, LinearProgress, Tooltip } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Api } from '../../../api/api';
import { endPoints } from '../../../api/apiEndpoints';
import Card from '../../../components/layout/Card';
import { Download } from '@mui/icons-material';
import moment from 'moment';
import ReadMoreReact from 'read-more-react/dist/components/ReadMoreReact';
import Table from '../../../components/table/Table';
import { setAllComplaintForms } from '../../../redux/slices/complaintForms/complaintForms';
import { CSVLink } from 'react-csv';
import DeleteModal from '../../../components/deletemodal/DeleteModal';
import DeleteIcon from '@mui/icons-material/Delete';
import { successNotify } from '../../../utils/helper';


const ComplaintForms = () => {
	const dispatch = useDispatch();

	const { complaintForms } = useSelector((state) => state.complaintForms);
	const [isLoading, setIsLoading] = useState(false);
	const [rowData, setRowData] = useState([]);
	const [openDeleteModal, setOpenDeleteModal] = useState(false);
	const [formData, setFormData] = useState({
		id: '',
	});
	const [currentParams, setCurrentParams] = useState({
		limit: 10,
		page: 1,
		totalPages: 0,
		totalRecords: 0,
	});

	const csvLink = useRef();


	const handleOpenDeleteModal = (val) => {
		setFormData({ id: val.id })
		setOpenDeleteModal(true)
	};

	const handleCloseDeleteModal = () => {
		setOpenDeleteModal(false)
	};

	const getComplaintForms = async (limit, page) => {
		setIsLoading(true)
		try {

			await Api.post(`${endPoints?.complaintForms?.fetch}`, {
				"limit": limit || 10,
				"page": page || 1
			}, {
				headers: {
					'xt-user-token': null
				}
			})
				.then((response) => {
					dispatch(
						setAllComplaintForms(
							response?.data?.data?.contact?.inquiries?.map((d, index) => ({
								index: index + 1,
								id: d?.id,
								user_id: d?.user_id,
								first_name: d?.first_name,
								last_name: d?.last_name,
								email_address: d?.email_address,
								message: d?.message,
								dt: d?.dt,
							})
							),
						),
					);
					const { page, limit, totalPages, totalRecords } = response?.data?.data?.contact?.pagination;
					setCurrentParams({ page, limit, totalPages, totalRecords });

					setIsLoading(false)

				})
				.catch((error) => {
					// if (error?.response?.status === 400) {
					// 	errorNotify(error?.response?.data);
					// 	setDisabledBtn(false);
					// }
					// setErrMsg(error?.response?.data?.message || errorMsg);
				});
		} catch (err) {
			// setErrMsg('Login Failed');
			// setDisabledBtn(false);
		}
	};


	const handleDownload = (row) => {

		let exportData = [
			{
				id: row.id,
				user_id: row.user_id,
				first_name: row.first_name,
				last_name: row.last_name,
				email_address: row.email_address,
				message: row.message,
				dt: row.dt,
			},
		];

		setRowData(exportData);

		setTimeout(() => {
			csvLink.current.link.click();
		}, 1000);
	}

	const handleDelete = async () => {
		try {

			await Api.post(endPoints?.complaintForms?.delete, {
				...formData,
				status: false
			}, {
				headers: {
					'xt-user-token': null
				}
			})
				.then((response) => {
					handleCloseDeleteModal();
					successNotify("Email Deleted Successfully")
					getComplaintForms();

				})
				.catch((error) => {

				});

		} catch (err) {
		}
	};


	useEffect(() => {
		getComplaintForms();
	}, [])


	const column = [
		{
			title: 'Id',
			field: 'id',
			render: (rowData) => <h4 className='font-face-R'>{rowData?.id}</h4>,
		},
		{
			title: 'User Id',
			field: 'user_id',
			render: (rowData) => <h4 className='font-face-R'>{rowData?.user_id}</h4>,
		},
		{
			title: 'First Name',
			field: 'first_name',
			render: (rowData) => <h4 className='font-face-R'>{rowData?.first_name}</h4>,
		},
		{
			title: 'Last Name',
			field: 'last_name',
			render: (rowData) => <h4 className='font-face-R'>{rowData?.last_name}</h4>,
		},
		{
			title: 'Email',
			field: 'email_address',
			render: (rowData) => <h4 className='font-face-R'>{rowData?.email_address}</h4>,
		},
		{
			title: 'Message',
			field: 'message',
			render: (rowData) => <h4 className='font-face-R'>{
				rowData?.message?.length > 15 ?
					<ReadMoreReact
						text={rowData?.message}
						min={10}
						ideal={15}
						max={rowData?.message?.length}
						readMoreText="Read More"
					/> : rowData?.message}</h4>,
		},
		{
			title: 'Date',
			field: 'dt',
			width: "10%",
			render: (rowData) => <h4 className='font-face-R'>{moment(rowData?.dt).format("DD-MM-YYYY")}</h4>,
		},
		{
			title: 'Download',
			field: 'download',
			filtering: false,
			render: (rowData) => (
				<Tooltip title='Download'>
					<IconButton onClick={() => handleDownload(rowData)} aria-label='Download'>
						<Download fontSize='large' />
					</IconButton>
				</Tooltip>
			),
		},
		{
			title: 'Delete',
			field: 'delete',
			filtering: false,
			render: (rowData) => (
				<Tooltip title='Delete'>
					<IconButton onClick={() => handleOpenDeleteModal(rowData)} aria-label='Delete'>
						<DeleteIcon />
					</IconButton>
				</Tooltip>
			),
		},

	];



	return (
		<>

			<Card margin='3rem 1.5rem' padding='3rem'>


				{isLoading ?
					<Box sx={{ m: '5rem' }}>
						<LinearProgress color="success" />
					</Box>
					:
					<Table
						columns={column}
						tableData={complaintForms?.map((item) => ({ ...item }))}
						sorting
						columnsButton
						padding="3rem"
						showTitle
						paginationType='normal'
						titleHeading="Complaint Forms"
						showToolbar={true}
						pageSize={currentParams.limit}
						onChangeRowsPerPage={(event) => getComplaintForms(parseInt(event.target.value, 10), 1)}
						totalRecords={currentParams.totalRecords}
						handlePageChange={(event, newPage) => getComplaintForms(currentParams.limit, newPage + 1)}
						curPage={currentParams.page - 1}
					/>
				}
				{rowData &&
					<CSVLink
						data={rowData}
						ref={csvLink}
						className="hidden"
						filename={"complaint_form.csv"}
						target="_blank"

					/>
				}

				<DeleteModal
					open={openDeleteModal}
					handleClose={handleCloseDeleteModal}
					handleDelete={handleDelete}
				/>

			</Card>
		</>
	);
};

export default ComplaintForms;
